"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:no-any */
var core_1 = require("@angular/core");
var ng2_dragula_1 = require("ng2-dragula");
require("./sis-dynamic-chip-group.component.scss");
var SisDynamicChipGroupComponent = /** @class */ (function () {
    function SisDynamicChipGroupComponent(dragulaService) {
        this.dragulaService = dragulaService;
        this.width = 150;
        this.indent = 10;
        this.selectedItemsChange = new core_1.EventEmitter();
        this._draggableItems = undefined;
    }
    Object.defineProperty(SisDynamicChipGroupComponent.prototype, "items", {
        set: function (value) {
            var _this = this;
            this._items = value.map(function (item) { return _this.createListItem(item); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDynamicChipGroupComponent.prototype, "data", {
        set: function (data) {
            var _this = this;
            this._data = data.map(function (groupData) { return ({
                items: groupData.items.map(function (item) {
                    return _this.createListItem(item);
                }),
                name: groupData.name,
            }); });
            this.filteredData = this.filterGroupedData();
            if (this._selectedItems) {
                this._draggableItems = this._selectedItems;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisDynamicChipGroupComponent.prototype, "draggableItems", {
        get: function () {
            return this._draggableItems;
        },
        set: function (draggableItems) {
            this._draggableItems = draggableItems;
        },
        enumerable: true,
        configurable: true
    });
    SisDynamicChipGroupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dragulaService.drop.subscribe(function () {
            _this.selectedItemsChange.emit(_this._draggableItems);
        }, console.log);
    };
    /**
     * This method will handle all input changes
     * @param {SimpleChange} changes
     * @returns {void}
     * @public
     * @method
     */
    SisDynamicChipGroupComponent.prototype.ngOnChanges = function (changes) {
        if (changes['items'] && this._selectedItems !== this._items) {
            this._selectedItems = this._items;
            this._draggableItems = this._selectedItems;
        }
    };
    SisDynamicChipGroupComponent.prototype.delete = function (id, idToDelete) {
        this._items = this._selectedItems.filter(function (item) {
            return item.uniqueId !== idToDelete;
        });
        this._selectedItems = this._items;
        this.selectedItemsChange.emit(this._selectedItems);
        this._draggableItems = this._draggableItems.filter(function (value) {
            return value.uniqueId !== idToDelete;
        });
    };
    SisDynamicChipGroupComponent.prototype.click = function (index, id) {
        this.filteredData = this.filterGroupedData();
        this.isComboOpened = true;
    };
    SisDynamicChipGroupComponent.prototype.closeCombobox = function (isClosed) {
        if (isClosed) {
            this.isComboOpened = false;
        }
    };
    SisDynamicChipGroupComponent.prototype.setValue = function (value) {
        if (value) {
            var selectedValues = this._selectedItems.slice();
            var path = {
                id: value.value.id,
                name: value.name,
                comboItem: value.comboItem,
                uniqueId: this.uniqueId(),
            };
            selectedValues.push(path);
            this._items = selectedValues;
            this._selectedItems = this._items;
            this.selectedItemsChange.emit(this._selectedItems);
            this._draggableItems = selectedValues;
        }
    };
    SisDynamicChipGroupComponent.prototype.onComboItemChange = function (comboItem, changedId) {
        if (comboItem) {
            var itemChanged = this._selectedItems.find(function (item) { return item.uniqueId === changedId; });
            if (itemChanged) {
                itemChanged.comboItem = comboItem;
                this._draggableItems = this._selectedItems;
                this.selectedItemsChange.emit(this._selectedItems);
            }
        }
    };
    SisDynamicChipGroupComponent.prototype.createListItem = function (value) {
        return {
            id: value[this.idField],
            name: value[this.nameField],
            comboItem: value[this.comboItemField],
            uniqueId: this.uniqueId(),
        };
    };
    SisDynamicChipGroupComponent.prototype.uniqueId = function () {
        return 'xxxxxxxx'.replace(/[xy]/g, function (c) {
            // tslint:disable:no-bitwise
            var r = (Math.random() * 16) | 0, // NOSONAR
            // tslint:disable-next-line:no-bitwise
            v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
            // tslint:enable:no-bitwise
        });
    };
    SisDynamicChipGroupComponent.prototype.filterGroupedData = function () {
        return this._data
            .map(function (group) { return ({
            name: group.name,
            items: group.items.map(function (item) { return ({
                name: item.name,
                value: {
                    id: item.id,
                },
                comboItem: item.comboItem,
            }); }),
        }); })
            .filter(function (group) {
            return group.items.length > 0;
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDynamicChipGroupComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDynamicChipGroupComponent.prototype, "placeholder", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisDynamicChipGroupComponent.prototype, "maxCount", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisDynamicChipGroupComponent.prototype, "comboItems", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDynamicChipGroupComponent.prototype, "nameField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDynamicChipGroupComponent.prototype, "idField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisDynamicChipGroupComponent.prototype, "comboItemField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisDynamicChipGroupComponent.prototype, "isHierarchical", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisDynamicChipGroupComponent.prototype, "width", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisDynamicChipGroupComponent.prototype, "indent", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisDynamicChipGroupComponent.prototype, "disabled", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisDynamicChipGroupComponent.prototype, "selectedItemsChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], SisDynamicChipGroupComponent.prototype, "items", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], SisDynamicChipGroupComponent.prototype, "data", null);
    SisDynamicChipGroupComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-dynamic-chip-group-combo',
            template: require('./sis-dynamic-chip-group.component.html'),
            providers: [ng2_dragula_1.DragulaService],
        }),
        __metadata("design:paramtypes", [ng2_dragula_1.DragulaService])
    ], SisDynamicChipGroupComponent);
    return SisDynamicChipGroupComponent;
}());
exports.SisDynamicChipGroupComponent = SisDynamicChipGroupComponent;
//# sourceMappingURL=sis-dynamic-chip-group.component.js.map